/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramResponseDto } from '../../models/program-response-dto';

export interface GetAllCustomersProgram$Params {
  programName: string;
}

export function getAllCustomersProgram(http: HttpClient, rootUrl: string, params: GetAllCustomersProgram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProgramResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllCustomersProgram.PATH, 'get');
  if (params) {
    rb.query('programName', params.programName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProgramResponseDto>>;
    })
  );
}

getAllCustomersProgram.PATH = '/ebs-programs/all-customers';
